import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from '../../../../services/AxiosInstance';
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

const ClientList = (props) =>{
    const { _id, clientname,clientemail,bokkingdesk,aboutus,companygstno,domainname,buyorsellrate,pramotersname,bankname,branchname,accountno,ifsccode,callingnumber,watsappnumber  } = props.obj;
    let history = useHistory();
    const deleteCompany = () => {
      axios
         .delete(
         "/company/companymasters/" + _id)
            .then((res) => {
               if (res.status === 200) {
               alert("Company successfully deleted");
               window.location.reload();
               } else Promise.reject();
            })
            .catch((err) => alert("Something went wrong"));
      };
      const drop = (
        <Dropdown>
           <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                 <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                    <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                    <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                 </g>
              </svg>
           </Dropdown.Toggle>
           <Dropdown.Menu>
              <Dropdown.Item>
                 <Link className="edit-link" 
                     to={"/edit-company/" + _id}>
                     Edit
                  </Link>
               </Dropdown.Item>
              <Dropdown.Item  onClick={deleteCompany}  className="text-danger">
                  Delete
              </Dropdown.Item>
           </Dropdown.Menu>
        </Dropdown>
     );
    return (
        <tr className="btn-reveal-trigger">
          <td className="py-3">{clientname}</td>
          <td className="py-3">{clientemail}</td>
          <td className="py-3">{watsappnumber}</td>
          <td className="py-3">{callingnumber}</td>
          {/* <td className="py-3">{bokkingdesk}</td>
          <td className="py-3">{aboutus}</td> */}
          <td className="py-3">{companygstno}</td>
          <td className="py-3">{domainname}</td>
          <td className="py-3">{bankname}</td>
          <td className="py-3">{branchname}</td>
          <td className="py-3">{accountno}</td>
          <td className="py-3">{ifsccode}</td>
          {/* <td className="py-2 text-right">{drop}</td> */}
        </tr>
    );
}
export default ClientList;